/* @flow */
const getElementoPorId = (id: string): HTMLElement => {
    const elemento = document.getElementById(id);
    if (!elemento) {
        throw new Error(`${id} não econtrado no documento`);
    }
    return elemento;
};

const getInputPorId = (id: string): HTMLInputElement => {
    const input = document.getElementById(id);
    if (!input) {
        throw new TypeError(`#${id} não encontrado no documento.`);
    }

    if (input instanceof HTMLInputElement) {
        return input;
    }

    throw new TypeError(`#${id} não é um input.`);
};

const getSelectPorId = (id: string): HTMLSelectElement => {
    const input = document.getElementById(id);
    if (!input) {
        throw new TypeError(`#${id} não encontrado no documento.`);
    }

    if (input instanceof HTMLSelectElement) {
        return input;
    }

    throw new TypeError(`#${id} não é um input.`);
};

// código
const form = getElementoPorId('calculadoraComissao');

const getValorComissao = () => {
    const appDelivery = getSelectPorId('appDelivery');

    if (appDelivery.value === 'ifood') {
        return 15 / 100;
    } if (appDelivery.value === 'rappi') {
        return 25 / 100;
    } if (appDelivery.value === 'ubereats') {
        return 30 / 100;
    } if (appDelivery.value === 'pedidosja') {
        return 15 / 100;
    } if (appDelivery.value === 'outros') {
        return 15.5 / 100;
    }
    return 0;
};

const conta = () => {
    const faturamentoString = getInputPorId('faturamentos').value;
    const porcentagemString = getInputPorId('porcentagem').value;
    const faturamento = parseFloat(faturamentoString);
    const porcentagem = parseFloat(porcentagemString);
    const comissao = getValorComissao();

    if (porcentagem > 100) {
        throw new Error('A porcentagem não pode ser maior que 100!');
    }
    if (faturamento <= 0) {
        throw new Error('O faturamento não pode ser vazio!');
    }
    const porcentagemCerta = porcentagem / 100;

    const total = porcentagemCerta * faturamento * comissao;

    return total;
};

form.onsubmit = (e) => {
    e.preventDefault();
    const totalAno = conta() * 12;

    /* eslint-disable */
    // $FlowFixMe
    $('#modalCalculadora').modal();
    $('#mes').text(`R$ ${conta()},00`);
    $('#ano').text(`R$ ${totalAno},00`);
    /* eslint-enable */
};
